import React from 'react';
import { Alert, Card, Col, Row, Badge } from 'react-bootstrap';
import { CustomButton } from '../../../../shared/customButton';
import styles from './emailReview.module.scss';

function EmailReview(props) {

    const textToRepace = props.emailData.templateWrapper;
    const content = textToRepace.replace('{special_placeholder_template_body}', props.emailData.templateBody);
    const content_body = content.replace(/{candidate_first_name}/g, 'John');

    return (
        <div>
            <Row>
                <Col>
                    <p className={styles.stepSubtopicName}>Email Template Configurations</p>
                </Col>
            </Row>
            <hr className={styles.subTopicDivider} />
            <div className='mt-4'>
                <Col>
                    <Row className={styles.emailDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>To</span>&nbsp;<span className={styles.rowValues}>
                                {(props.candidateEmail).length !== 0 &&
                        
                                    <Row className="ml-0 mr-0">
                                        {
                                            (props.candidateEmail).map((item, i) => (
                                                (
                                                    <div className={styles.emailbadgeDiv} key={i}>
                                                        <Badge variant="primary" className={styles.emailbadge}>{item}&nbsp;&nbsp;
                                                            
                                                        </Badge>
                                                    </div>
                                                )
                                            ))
                                        }
                                    </Row>
                                }
                            </span>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row className={styles.emailDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Email&nbsp;Subject:</span>&nbsp;<span className={styles.rowValues}>{props.emailData.email_subject}</span>
                        </Col>
                    </Row>
                </Col>
                
                <Card className={styles.contentCard}>
                    <Card.Body>
                        <div dangerouslySetInnerHTML={{ __html: content_body}}></div>
                    </Card.Body>
                </Card>
                <Col className='mt-3'>
                    <Row className={styles.actionBtns}>
                        <Col className="pl-0">
                            {<CustomButton
                                buttonType="button"
                                label="Back"
                                type="defaultBtn"
                                disabled={props.submissionLoading?true:false}
                                handleClick={() => props.previousPage(1)}

                            />}
                        </Col>
                        <Col className="pr-0">
                            {<CustomButton
                                buttonType="button"
                                label="Submit"
                                type="primaryBtn"
                                disabled={props.submissionLoading ? true : false}
                                handleClick={() => props.submitEmailTemplateValues()}
                                backicon={props.submissionLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                            />}
                        </Col>
                    </Row>
                </Col>
            </div>
        </div>
    )
}

export default EmailReview;
